import React from 'react';
import { Card, CardContent } from '@/components/ui';

export interface LogItem {
  id: string;
  user: string;
  action: string;
  timestamp: string;
  type: 'user' | 'system' | 'role' | 'setting' | 'backup';
}

export function ActivityLog() {
  const logs: LogItem[] = [
    { id: '1', user: 'admin', action: 'Đăng nhập hệ thống', timestamp: '15/05/2024 08:45:12', type: 'user' },
    { id: '2', user: 'admin', action: 'Thêm mới người dùng: nguyen.van.a', timestamp: '15/05/2024 08:30:01', type: 'user' },
    { id: '3', user: 'admin', action: 'Cập nhật vai trò: Quản lý dự án', timestamp: '15/05/2024 08:15:45', type: 'role' },
    { id: '4', user: 'admin', action: 'Cập nhật cài đặt hệ thống', timestamp: '15/05/2024 07:50:22', type: 'setting' },
    { id: '5', user: 'system', action: 'Sao lưu dữ liệu hệ thống', timestamp: '15/05/2024 02:00:00', type: 'backup' },
  ];

  const getIcon = (type: string) => {
    switch (type) {
      case 'user': return { icon: 'ri-user-follow-line', color: 'bg-blue-50 text-blue-500' };
      case 'role': return { icon: 'ri-shield-user-line', color: 'bg-purple-50 text-purple-500' };
      case 'setting': return { icon: 'ri-settings-4-line', color: 'bg-orange-50 text-orange-500' };
      case 'backup': return { icon: 'ri-database-2-line', color: 'bg-blue-50 text-blue-600' };
      default: return { icon: 'ri-history-line', color: 'bg-slate-50 text-slate-400' };
    }
  };

  return (
    <Card className="border-none shadow-sm h-full flex flex-col">
      <CardContent className="p-6 flex-1 flex flex-col">
        <div className="flex justify-between items-center mb-6">
          <h3 className="text-sm font-bold text-slate-800">Nhật ký hoạt động gần đây</h3>
          <button className="text-[10px] font-bold text-blue-500 hover:underline">Xem tất cả</button>
        </div>

        <div className="flex-1 space-y-4">
          {logs.map((log) => {
            const config = getIcon(log.type);
            return (
              <div key={log.id} className="flex justify-between items-start gap-4">
                <div className="flex gap-3 min-w-0">
                  <div className={`w-8 h-8 rounded-lg ${config.color} flex items-center justify-center shrink-0`}>
                    <i className={`${config.icon} text-sm`} />
                  </div>
                  <div className="min-w-0">
                    <p className="text-xs font-bold text-slate-700 truncate leading-tight mb-1">
                      <span className="text-blue-600 mr-2">{log.user}</span>
                      {log.action}
                    </p>
                  </div>
                </div>
                <span className="text-[10px] font-bold text-slate-400 whitespace-nowrap">{log.timestamp}</span>
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
}
